<template>
  <v-dialog v-model="isOpen" persistent width="520">
    <v-card>
      <v-card-title class="title-text-custom">
        {{$t('ThirdPartyTermsOfService')}}
      </v-card-title>

      <v-card-text>
        <div style="margin-left: -15px;margin-top:-20px" class="d-flex pa-4">
          <InputField
              inputType="checkbox"
              :value="term1"
              :checkbox-options=agreeThirdPartyConsumableCheckbox
              @input="term1=!term1"
              :height=15
              :width=15
              :border="'1px solid'"
              :size="'100'"
              :inputStyle="inputStyle"
              :checkboxLabelStyle="checkboxLabelStyle"
            />
        </div>
        <div style="margin-left: -15px;margin-bottom: 30px;" class="d-flex pa-4">
          <InputField
              inputType="checkbox"
              :value="term2"
              :checkbox-options=agreeToServiceTermsCheckbox
              @input="term2=!term2"
              :height=15
              :width=15
              :border="'1px solid'"
              :size="'100'"
              :inputStyle="inputStyle"
              :checkboxLabelStyle="checkboxLabelStyleTerm2"
            />
        </div>
       
      </v-card-text>
       <div class="action-buttons">
      <custom-button
        :label="$t('Cancel')"
        :button-color="'#FFF'"
        :label-color="'#29BDF0'"
        :button-styling="actionButtonsStyling"
        @buttonClick="clearTerms();$emit('cancelMap')"
      />
      <custom-button
        :label="$t('Add')"
        :button-color="'#29BDF0'"
        :label-color="'#FFF'"
        :button-styling="actionButtonsStylingSave"
        :disabled="!term1 || !term2"
        @buttonClick="clearTerms();$emit('createMap')" 
      />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import CustomCheckbox from "@/newComponents/_Atoms/CustomCheckbox";
import InputField from "@/newComponents/_Atoms/InputField";
import CustomButton from '@/newComponents/_Atoms/CustomButton'
export default {

  name: "ThirdPartyDialog",

  components: {
    CustomCheckbox,
    InputField,
    CustomButton
  },

   props: {
    isOpen: {
      type: Boolean,
      required: true,
    }
  },

  data() {
    return {
      term1: false,
      term2: false,
      inputStyle: {
        'border': '1px solid',
      },
      checkboxLabelStyle: {
        'font-size': '13px',
        'text-align': 'start',
        'color': '#231E46',
        'font-family': 'Lato',
        'margin-left': '30px',
        'margin-bottom': '-12px'
      },
      checkboxLabelStyleTerm2: {
        'font-size': '13px',
        'text-align': 'start',
        'color': '#231E46',
        'font-family': 'Lato',
        'margin-left': '30px',
        'margin-bottom': '-30px'
      },
      actionButtonsStyling: {
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      actionButtonsStylingSave: {
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
    };
  },

  methods: {
    clearTerms() {
      this.term1 = false;
      this.term2 = false;
    }
  },

  computed: {
    agreeThirdPartyConsumableCheckbox() {
      return [
        {
          id: 1,
          label: this.$i18n.t('agreeThirdPartyConsumable')
        }
      ]
    },
    agreeToServiceTermsCheckbox(){
      return [
        {
          id:2,
          label: this.$i18n.t('agreeToServiceTerms')
        }
      ]
    }
  }
}
</script>

<style scoped>
.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
  padding-bottom:30px;
  margin-right:60px;
}

.title-text-custom {
  color: #231E46 !important;
  font-feature-settings: "clig" off, "liga" off !important;
  font-size: 1.3rem !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 1.47531rem !important;
  font-family: Lato !important;
  text-transform: uppercase;
}

.v-dialog>.v-card>.v-card__title {
  padding: 35px 45px 32px
}

</style>



// WEBPACK FOOTER //
// src/newComponents/Maps/ThirdPartyDialog.vue